import React from 'react';
import DashboardButton from './DashboardButton';
import ArrowIcon from '/src/assets/images/button/arrow-left-circle.svg?url';
const ButtonIdentify: React.FC = () => (
  <DashboardButton
    label="ورود به هویت"
    width={100}
    height={24}
    backgroundColor="transparent"
    textColor="#2563EB"
    borderRadius="35px"
    endIcon={
      <img
        src={ArrowIcon}
        alt="Plus Icon"
        style={{ width: '14px', height: '14px', marginLeft: '2px', marginRight: '0px' }}
      />
    }
  />
);

export default ButtonIdentify;
